export default {
  type: "Feature",
  properties: {
    name: "Өлгий",
    location: [48.56804901337627, 88.51228228494055],
  },
  geometry: {
    type: "Polygon",
    coordinates: [
      [
        [91.04844331741333, 46.719850466635805],
        [91.04838967323302, 46.71986517728791],
        [90.98602294921875, 46.76808718675661],
        [90.98602294921875, 46.794418663019734],
        [90.93658447265625, 46.81885778879603],
        [90.94757080078124, 46.875213396722685],
        [90.90911865234374, 46.916503267244835],
        [90.92010498046875, 46.93901161506044],
        [90.81024169921875, 46.991494313050424],
        [90.76080322265624, 46.98587362966408],
        [90.7305908203125, 47.02146130911727],
        [90.648193359375, 47.11499982620772],
        [90.56304931640625, 47.20650833393471],
        [90.5108642578125, 47.301584511330795],
        [90.48065185546874, 47.320206883852414],
        [90.50811767578125, 47.3425450696602],
        [90.4998779296875, 47.39834920035926],
        [90.45867919921875, 47.409502941311075],
        [90.47241210937499, 47.48565697095909],
        [90.4010009765625, 47.535746978239125],
        [90.3460693359375, 47.62467785241324],
        [90.37353515625, 47.646886969413],
        [90.252685546875, 47.70421683390384],
        [90.12359619140625, 47.72823964536174],
        [90.06866455078125, 47.78178908571311],
        [90.07415771484375, 47.857402894658236],
        [89.9560546875, 47.88503897004144],
        [89.95880126953125, 47.833439707627605],
        [89.76104736328125, 47.82975208084834],
        [89.73358154296875, 47.864773955792245],
        [89.7528076171875, 47.879512933970496],
        [89.72259521484375, 47.89608927375508],
        [89.65118408203125, 47.907137219641115],
        [89.6429443359375, 47.94394667836211],
        [89.59075927734375, 47.97521412341618],
        [89.58251953125, 48.028509034432986],
        [89.40948486328125, 48.03034580796616],
        [89.28863525390625, 48.01381248943335],
        [89.23370361328125, 47.97521412341618],
        [89.1595458984375, 47.9954359160952],
        [89.11560058593749, 47.98256841921402],
        [89.05517578125, 47.98624517426206],
        [88.93157958984375, 48.10559716402152],
        [88.846435546875, 48.10926514749487],
        [88.81622314453125, 48.09642606004488],
        [88.692626953125, 48.17524408990215],
        [88.66241455078125, 48.1642534885474],
        [88.59100341796875, 48.22101291025667],
        [88.59374999999999, 48.25211235426607],
        [88.57177734375, 48.272225451004324],
        [88.604736328125, 48.334343174592014],
        [88.49212646484374, 48.40185599006367],
        [88.4344482421875, 48.38909015961602],
        [88.34930419921875, 48.42920055556841],
        [88.35205078124999, 48.46017328524599],
        [88.2147216796875, 48.500227605781035],
        [88.17626953125, 48.4965876108066],
        [88.13232421875, 48.52933815687993],
        [88.0059814453125, 48.552978164400734],
        [87.95379638671874, 48.59477574898104],
        [88.0279541015625, 48.63290858589532],
        [88.0059814453125, 48.65105695744788],
        [88.08563232421875, 48.7127125814524],
        [87.95928955078125, 48.77067246880509],
        [87.93731689453125, 48.75618876280552],
        [87.8631591796875, 48.801436476249386],
        [87.7972412109375, 48.81952414194507],
        [87.77526855468749, 48.87013489622034],
        [87.74505615234375, 48.87013489622034],
        [87.75054931640625, 48.92430395329745],
        [87.8082275390625, 48.94415123418794],
        [87.87689208984375, 48.956777213851424],
        [87.90435791015625, 48.982019588328214],
        [87.83294677734375, 49.04214406667087],
        [87.82848358154297, 49.05114522570259],
        [87.8353500366211, 49.0600322713146],
        [87.85457611083984, 49.070717120839156],
        [87.83775329589842, 49.08196184888935],
        [87.85388946533203, 49.11905139208892],
        [87.8353500366211, 49.13702422419125],
        [87.83294677734375, 49.14600819722733],
        [87.82985687255858, 49.149601330435864],
        [87.81818389892578, 49.145109873210956],
        [87.81166076660156, 49.1536432938359],
        [87.82093048095703, 49.16509373263508],
        [87.81452536582947, 49.17018664326377],
        [87.81453609466553, 49.1701726139265],
        [87.81972885131836, 49.17418484235879],
        [87.82281875610352, 49.17788814921708],
        [87.83105850219727, 49.176429303833146],
        [87.84736633300781, 49.17766371426438],
        [87.85423278808594, 49.175980419679945],
        [87.86144256591797, 49.17811258315209],
        [87.86985397338867, 49.174633742795336],
        [87.87483215332031, 49.17137912239958],
        [87.87946701049805, 49.172276970087815],
        [87.8847885131836, 49.17194027911297],
        [87.89302825927734, 49.176092641099864],
        [87.90384292602538, 49.17755149640637],
        [87.91156768798828, 49.174297067849565],
        [87.91912078857422, 49.1729503451679],
        [87.92736053466797, 49.17452151806784],
        [87.93130874633789, 49.17990801799526],
        [87.94332504272461, 49.18136676084692],
        [87.9465866088867, 49.18058128926962],
        [87.94916152954102, 49.18125455138487],
        [87.95190811157227, 49.18349869228674],
        [87.9568862915039, 49.18551833208798],
        [87.96598434448241, 49.18383530464464],
        [87.97611236572266, 49.18652812107726],
        [87.98091888427734, 49.184284117560004],
        [87.98778533935547, 49.182825460701736],
        [88.0030632019043, 49.1999900051565],
        [88.00083160400389, 49.208626117966396],
        [88.00649642944336, 49.20952328994859],
        [88.01130294799805, 49.2140089056539],
        [88.01336288452148, 49.218381989099505],
        [88.01971435546875, 49.2207365660853],
        [88.01816940307617, 49.22645435746312],
        [88.0305290222168, 49.2327319545609],
        [88.05507659912108, 49.23990537453461],
        [88.05730819702148, 49.24293134862419],
        [88.05524826049805, 49.25111175765098],
        [88.05164337158203, 49.25223225608003],
        [88.05164337158203, 49.25626583984384],
        [88.06297302246092, 49.26018706362073],
        [88.07344436645508, 49.25917877869041],
        [88.08202743530273, 49.26108329959868],
        [88.08125495910645, 49.258842679135945],
        [88.0840015411377, 49.2554255370738],
        [88.08940887451172, 49.254641241581595],
        [88.09507369995117, 49.255873700331406],
        [88.10099601745605, 49.25503339088543],
        [88.10666084289551, 49.25592972045248],
        [88.11103820800781, 49.26158742518368],
        [88.11567306518555, 49.265116160083664],
        [88.11661720275879, 49.267972570183545],
        [88.12331199645996, 49.272620884054454],
        [88.12339782714844, 49.27530886569056],
        [88.12580108642577, 49.27822068050448],
        [88.12949180603027, 49.279620530283694],
        [88.13172340393065, 49.279620530283694],
        [88.13575744628906, 49.27956453705538],
        [88.13764572143553, 49.280964348691164],
        [88.14013481140137, 49.27995648831844],
        [88.14957618713379, 49.281748225852034],
        [88.1539535522461, 49.286843123686374],
        [88.16253662109375, 49.28919443744276],
        [88.1597900390625, 49.31706575342583],
        [88.17214965820311, 49.326912087086605],
        [88.15841674804688, 49.337651296668845],
        [88.165283203125, 49.350177413469],
        [88.1597900390625, 49.36270034165353],
        [88.121337890625, 49.37432592004196],
        [88.1158447265625, 49.38952445158216],
        [88.1707763671875, 49.41276017251568],
        [88.18588256835938, 49.41633392300034],
        [88.17352294921875, 49.44044993310386],
        [88.1707763671875, 49.453842594330744],
        [88.21884155273436, 49.47972469948566],
        [88.24081420898438, 49.47704787438876],
        [88.25866699218749, 49.48150916826499],
        [88.3026123046875, 49.47169378524674],
        [88.319091796875, 49.47347854665752],
        [88.32321166992188, 49.485077910741936],
        [88.33145141601562, 49.49399862898744],
        [88.36715698242186, 49.48418574950772],
        [88.385009765625, 49.48686218444083],
        [88.40835571289062, 49.49489061140408],
        [88.44406127929688, 49.472586174080966],
        [88.49624633789062, 49.47347854665752],
        [88.52645874023438, 49.48597005571962],
        [88.55255126953125, 49.48686218444083],
        [88.58688354492188, 49.50024216453777],
        [88.61297607421875, 49.49667452747045],
        [88.63220214843749, 49.49578257756505],
        [88.67340087890625, 49.46544660818596],
        [88.73245239257812, 49.450271575719945],
        [88.74893188476561, 49.46187643504186],
        [88.79974365234375, 49.459198634468564],
        [88.8409423828125, 49.44134289100633],
        [88.86566162109375, 49.45830600175986],
        [88.85330200195312, 49.46723159720791],
        [88.868408203125, 49.46990895880499],
        [88.87527465820312, 49.47704787438876],
        [88.86016845703125, 49.489538473066474],
        [88.88214111328124, 49.50826839701879],
        [88.87527465820312, 49.54659778073743],
        [88.88076782226562, 49.55639814511971],
        [88.9013671875, 49.55728898983402],
        [88.92608642578125, 49.54303352434694],
        [88.93569946289062, 49.513618487218466],
        [88.96041870117186, 49.4984583785148],
        [88.97140502929688, 49.46455408928758],
        [89.00299072265625, 49.4690165211973],
        [89.03732299804688, 49.48597005571962],
        [89.07852172851562, 49.48418574950772],
        [89.12246704101562, 49.50202588554],
        [89.14581298828125, 49.50113403316642],
        [89.16229248046874, 49.515401720585665],
        [89.20074462890625, 49.522534003908106],
        [89.23507690429688, 49.55461640694068],
        [89.197998046875, 49.58756804188785],
        [89.197998046875, 49.61070993807422],
        [89.18563842773436, 49.621387109259516],
        [89.24057006835936, 49.647180616086885],
        [89.3353271484375, 49.596470070892686],
        [89.384765625, 49.603590524348704],
        [89.4287109375, 49.621387109259516],
        [89.4561767578125, 49.66051672522669],
        [89.53857421875, 49.688954878870334],
        [89.7198486328125, 49.73513141624827],
        [89.7198486328125, 49.78835749241401],
        [89.659423828125, 49.78835749241401],
        [89.6209716796875, 49.80254124506291],
        [89.62646484375, 49.84506757956392],
        [89.62646484375, 49.898172936240364],
        [89.593505859375, 49.91939873027269],
        [89.71435546875, 49.94415035164548],
        [90.0054931640625, 49.993615462541136],
        [90.02540588378906, 50.00023639420785],
        [90.02540588378906, 50.00023639420785],
        [90.04600524902344, 49.983461596534674],
        [90.07965087890625, 49.97418880321091],
        [90.12908935546874, 49.917630270866894],
        [90.16754150390625, 49.807859081298325],
        [90.21697998046875, 49.742231602580716],
        [90.3021240234375, 49.692508478893274],
        [90.40924072265625, 49.648069803718805],
        [90.5108642578125, 49.5822260446217],
        [90.59051513671875, 49.47169378524674],
        [90.59051513671875, 49.42884000063522],
        [90.62072753906249, 49.40203735979645],
        [90.6646728515625, 49.33407182046059],
        [90.74432373046875, 49.30005381244688],
        [90.81298828125, 49.30721745093609],
        [90.8953857421875, 49.28393181795616],
        [90.9393310546875, 49.1888842152458],
        [91.00250244140624, 49.09904896047899],
        [91.02447509765625, 49.04506962208049],
        [91.11785888671875, 48.97661158387714],
        [91.20849609375, 48.942347261978476],
        [91.2744140625, 48.8737479930069],
        [91.31977558135986, 48.77369880939393],
        [91.33822917938232, 48.671919512374565],
        [91.33827209472655, 48.671862832349746],
        [91.26033782958983, 48.702517412636006],
        [91.2205123901367, 48.7127125814524],
        [91.19510650634766, 48.71384525048727],
        [91.16901397705078, 48.710447166883384],
        [91.14086151123047, 48.70342373350562],
        [91.10172271728516, 48.68257422428195],
        [91.04679107666016, 48.65967514645313],
        [90.96576690673828, 48.63404305042837],
        [90.94310760498047, 48.630412674131264],
        [90.90808868408203, 48.62950503924253],
        [90.88233947753906, 48.633135480842654],
        [90.83427429199219, 48.64470577018957],
        [90.81436157226562, 48.6478814638068],
        [90.73917388916016, 48.65241782207755],
        [90.71891784667969, 48.63880752291323],
        [90.77934265136719, 48.58432959223574],
        [90.79891204833984, 48.56229474861628],
        [90.81024169921875, 48.54525091510785],
        [90.81710815429688, 48.525018116559266],
        [90.83324432373047, 48.453114986767304],
        [90.83427429199219, 48.412795581099964],
        [90.82019805908203, 48.34871995385989],
        [90.81745147705078, 48.29895447218437],
        [90.82054138183594, 48.272225451004324],
        [90.83427429199219, 48.22375773926874],
        [90.85487365722655, 48.11889235864144],
        [90.86585998535156, 48.09527955700514],
        [90.88680267333984, 48.068444087227796],
        [90.9286880493164, 48.0406764393366],
        [90.94757080078124, 48.02414643492423],
        [90.98533630371094, 47.97521412341618],
        [91.05949401855469, 47.83989242396357],
        [91.07460021972656, 47.78155838741233],
        [91.08455657958984, 47.76494541923992],
        [91.0982894897461, 47.75109722475338],
        [91.11648559570312, 47.73955424703249],
        [91.1367416381836, 47.731010795533955],
        [91.17107391357422, 47.72246594225631],
        [91.1703872680664, 47.661225340769356],
        [91.17382049560545, 47.645036570200254],
        [91.1916732788086, 47.61287541946062],
        [91.21742248535156, 47.59273570820418],
        [91.25656127929688, 47.545712894408624],
        [91.26136779785156, 47.528561072779034],
        [91.26205444335938, 47.49493650511712],
        [91.2527847290039, 47.45989767565368],
        [91.2366485595703, 47.36905939398393],
        [91.28986358642578, 47.33510005753562],
        [91.35612487792969, 47.258961160390896],
        [91.40041351318358, 47.22749569440931],
        [91.44847869873047, 47.20697480997098],
        [91.46427154541016, 47.159139675920336],
        [91.46873474121094, 47.13041790553795],
        [91.46358489990234, 47.10565336099383],
        [91.44882202148438, 47.06310621972502],
        [91.44092559814453, 47.00835281693705],
        [91.44332885742188, 46.971350795196734],
        [91.45465850830077, 46.94369966371151],
        [91.49311065673828, 46.90688744465985],
        [91.51542663574219, 46.89234316754865],
        [91.5707015991211, 46.86605963365364],
        [91.63524627685547, 46.826845094695884],
        [91.70665740966797, 46.79629898997745],
        [91.76055908203125, 46.76926297371478],
        [91.86492919921875, 46.72950714675161],
        [91.92672729492188, 46.702673044474004],
        [91.87179565429688, 46.63717954716511],
        [91.83677673339842, 46.62256226021187],
        [91.77841186523438, 46.616431255357995],
        [91.56829833984375, 46.613601326659726],
        [91.50238037109375, 46.56735822330717],
        [91.43096923828124, 46.54280504427768],
        [91.34994506835938, 46.55886030311719],
        [91.31973266601562, 46.60133659339023],
        [91.27304077148438, 46.66263249079177],
        [91.16386413574219, 46.68995749641134],
        [91.10275268554688, 46.71209003858017],
        [91.05352878570557, 46.7231529074099],
        [91.04844331741333, 46.719850466635805],
      ],
    ],
  },
};
